import { isObject } from '@utils/type-guards/is-object'
import { SampleCartDTO } from '@services/cart'
import { TypeSample } from '@components/rug-builder/order-samples'

export const isSampleCartDTO = (obj: unknown): obj is SampleCartDTO => {
  return (
    isObject(obj) && (obj.type === TypeSample.WEAVE || obj.type === TypeSample.BORDER) && typeof obj.color === 'string'
  )
}
